import type { ComponentRegistry } from '@vibesites/runtime';
import {
  Header,
  Hero,
  PropertyOverview,
  SpecialOffers,
  CTASection,
  TabbedCallouts,
  FloorplansList,
  PhotoSlider,
  ConvenienceCallout,
  AmenitiesList,
  AmenitiesSummary,
  GalleryApartments,
  GalleryCommunity,
  NeighborhoodMap,
  VirtualTourEmbed,
  ContactForm,
  ContactMap,
  ScheduleTourForm,
  Fees,
  PageHero,
  PageBlurb,
  HeroSolidBG,
  Reviews,
  ReviewsCallout,
  PinnedCallouts,
  SocialFollow,
  SpecialOfferBanner,
  ResidentAccess,
  AccessibilityStatement,
  PrivacyPolicyContent,
  SitemapContent,
  HyperlocalHero,
  HyperlocalPageCopy,
  ThankYouContent,
  FutureResidentsClub,
  ApartmentSyncSection,
  Footer,
  Navigation,
  InteractiveMapSection,
  LetsConnect,
  Testimonials,
  WhiteStripe,
  PetPolicyInfo,
  FAQ,
} from './components';

export const registry: ComponentRegistry = {
  Header,
  Hero,
  PropertyOverview,
  SpecialOffers,
  CTASection,
  TabbedCallouts,
  FloorplansList,
  PhotoSlider,
  ConvenienceCallout,
  AmenitiesList,
  AmenitiesSummary,
  GalleryApartments,
  GalleryCommunity,
  NeighborhoodMap,
  VirtualTourEmbed,
  ContactForm,
  ContactMap,
  ScheduleTourForm,
  Fees,
  PageHero,
  PageBlurb,
  HeroSolidBG,
  Reviews,
  ReviewsCallout,
  PinnedCallouts,
  SocialFollow,
  SpecialOfferBanner,
  ResidentAccess,
  AccessibilityStatement,
  PrivacyPolicyContent,
  SitemapContent,
  HyperlocalHero,
  HyperlocalPageCopy,
  ThankYouContent,
  FutureResidentsClub,
  ApartmentSyncSection,
  Footer,
  Navigation,
  InteractiveMapSection,
  LetsConnect,
  Testimonials,
  WhiteStripe,
  PetPolicyInfo,
  FAQ,
};

export default registry;
